import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDialogHandle } from "../actions/dialog";
import PageLayout from "../components/Layout";
import AnalyticsDashboardSidebar from "../components/overview/AnalyticsDashboardSidebar";
import { ReportingVenuesDialog } from "../components/overview/ReportingVenuesDialog";
import { SuperuserOverview } from "../components/overview/SuperuserOverview";
import { OverviewHeader } from "../components/ui/OverviewHeader";
import ListLoading from "../components/util/Loading";
import { useGetAllVenues } from "../hooks/useGetAllVenues";
import { useIsSuperuser } from "../hooks/useIsSuperuser";
import useAcceptVenueInvitations from "../hooks/useAcceptVenueInvitations";
import { useReportingVenues } from "../hooks/useReportingVenues";
import AnalyticsDashboardView from "./AnalyticsDashboardView";
import IVenue from "../interfaces/IVenue";


function VenuesOverviewContainer() {
    const { t } = useTranslation();
    const { isSuperuser, merchant } = useIsSuperuser();
    const { checkAndAcceptInvitations, isLoading: isCheckingInvitations } = useAcceptVenueInvitations();
    const { isLoading, getAllVenues } = useGetAllVenues();
    const [ reportingVenues, setReportingVenues ] = useState<IVenue[]>();
    const { getReportingVenues } = useReportingVenues();
    const dispatch = useDispatch();

    function onAlertClick() {
        dispatch(setDialogHandle({
            Component: ReportingVenuesDialog,
            ComponentProps: {
                venueList: reportingVenues
            },
            isOpen: true,
            dialogTitle: t('permissions.overviewReportTitle')
        }))
    }

    useEffect(() => {
        if(!isLoading) {
            setReportingVenues(getReportingVenues());
        }
        //eslint-disable-next-line
    }, [isLoading]);
    
    useEffect(() => {
        if(merchant){
            checkAndAcceptInvitations(merchant.id).then(() => {
                getAllVenues();
            })
        }
        //eslint-disable-next-line
    }, [merchant]);

    return <PageLayout key="overview-layout"
        sidebar={true}  showHeader={true} title=""
        CustomSidebar={AnalyticsDashboardSidebar}
        CustomHeader={OverviewHeader}
        customSidebarProps={{
            isLoading : isLoading && !isSuperuser
        }}
        >
        {isSuperuser || reportingVenues?.length === 0 ?
            <SuperuserOverview />
            : isLoading || isCheckingInvitations ? <ListLoading /> :
                <AnalyticsDashboardView allVenues={true} venueList={reportingVenues} onAlertClick={onAlertClick} />
        }
    </PageLayout>
}


export default VenuesOverviewContainer;